var _circle, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcEllipse({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 35,
    r: 33.5,
    stroke: "url(#paint0_linear_42293_12391)",
    strokeWidth: 3
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_42293_12391",
    x1: 0,
    y1: 0,
    x2: 70,
    y2: 70,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.154412,
    stopColor: "#FFA233"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.840074,
    stopColor: "#0071BB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcEllipse);
export default __webpack_public_path__ + "static/media/ic_ellipse.5355f1df34642c3587f5b85885a8a18b.svg";
export { ForwardRef as ReactComponent };